var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"counter-warp"},[_c('p',[_vm._v("Vuex counter：\n    "+_vm._s(_vm.count)+"\n    ")]),_vm._v(" "),_c('p',[_c('button',{on:{"click":_vm.increment}},[_vm._v("+")]),_vm._v(" "),_c('button',{on:{"click":_vm.decrement}},[_vm._v("-")])]),_vm._v(" "),_c('a',{staticClass:"home",on:{"click":_vm.bindViewTap}},[_vm._v("去往首页")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32c44bda","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/counter/index.vue
// module id = null
// module chunks = 